import { Action } from 'redux';
import {
  SidePanelActionConstants,
  SidePanelState,
} from './types';

export const initialState: SidePanelState = {
  menuStatus: 'collapse',
};

export default function sidePanelReducer(
  state = initialState,
  action: Action<SidePanelActionConstants>,
): SidePanelState {
  switch (action.type) {
    case SidePanelActionConstants.MENU_EXTEND: {
      return {
        ...state,
        menuStatus: 'extend',
      };
    }
    case SidePanelActionConstants.MENU_COLLAPSE: {
      return {
        ...state,
        menuStatus: 'collapse',
      };
    }
    default:
      return state;
  }
}
